import React from 'react';
import {
  required,
  FormDataConsumer,
  List,
  SaveButton,
  Datagrid,
  DateField,
  TextField,
  BooleanField,
  NumberField,
  Edit,
  FormTab,
  TabbedForm,
  Toolbar,
  BooleanInput,
  TextInput,
  EditButton,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  Filter,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  ArrayField
} from 'react-admin';
import { Box, Typography } from '@material-ui/core';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import {ScheduledReportButton} from "./components/schedule_report_button.js";
const { validMaxLineSeparated } = require('./components/validation.js');

const validateListSize = (values) => validMaxLineSeparated(values, 50);

function priceAdustmentChoices() {
  const ret = [];
  for (let i =1; i<100; i++)  {
    ret.push({id: i, name: `${i}% Adjustment`});
  }
  return ret;
}

const CustomDateField = ({ record }) => {
  let date = '' + (record.updated_at || record.date);
  date = date.substring(0, date.indexOf('T'));
  return (
    <span>
      <nobr>{date}</nobr>
    </span>
  );
};

const BidderTitle = ({ record }) => {
  return (
    <span>
      Bidder {record ? `"${record.name}"` : ''}{' '}
      {record && record.active ? 'ACTIVE' : 'INACTIVE'}
    </span>
  );
};
/**
 * Adds filtering functionality
 * @param {} props
 */
const BidderFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);
export const BidderList = (props) => (
  <List
    {...props}
    filters={<BidderFilter />}
    perPage={25}
    bulkActionButtons={false}
  >
    <Datagrid rowClick="edit">
      <TextField source="code" label="ID" />
      <TextField source="name" label="Name" />
      <TextField source="bidder_type" label="Bidder Type" />
      <CustomDateField label="Update Date" />
      <BooleanField source="active" label="Active" />
      <EditButton variant="contained" color="primary" />
    </Datagrid>
  </List>
);
/**
 * TODO: add styling for markup bar to
 * @param {*} props
 */
export const BidderEdit = (props) => {
  return (
    <Edit title={<BidderTitle />} {...props}>
      <TabbedForm toolbar={<CustomToolbar />}>
        <FormTab label="Bidder">
          <BooleanInput source="active" label="Active" />

          <NumberField source="code" label="Bidder ID" validate={required()} />
          <TextInput source="name" label="Bidder Name" validate={required()} style={{width: '40%'}}/>
          <BooleanInput
            source="default"
            label="Default"
            defaultValue={false}
            style={{ width: '400px' }}
            validate={required()}
          />

          <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
            <Box flex={1} mr={{ xs: 0, sm: '1em' }}>
              <SelectInput
                source="bidder_type"
                label="Bidder Type"
                emptyText="- None -"
                allowEmpty
                choices={[
                  { id: 'RTB', name: 'RTB' },
                  { id: 'PREDICTOR', name: 'PREDICTOR' },
                ]}
                fullWidth
              />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: '1em' }}>
              <NumberInput
                source="serving_fee"
                label="GAM Serving Fee %"
                helperText="Taken out at reporting time"
                fullWidth
              />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: '1em' }}>
              <SelectInput
                source="impression_type"
                label="Impression Type"
                emptyText="- None -"
                defaultValue={'BANNER'}
                choices={[
                  { id: 'BANNER', name: 'Banner' },
                  { id: 'VIDEO', name: 'Video' },
                  { id: 'AUDIO', name: 'Audio' },
                  { id: 'NATIVE', name: 'Native' },
                ]}
                fullWidth
              />
            </Box>

            <Box flex={1} mr={{ xs: 0, sm: '1em' }}>
              <SelectInput
                source="native_response_type"
                label="Native Response Type"
                emptyText="- None -"
                defaultValue={'NATIVE'}
                choices={[
                  { id: 'BANNER', name: 'BANNER' },
                  { id: 'NATIVE', name: 'NATIVE' },
                ]}
                fullWidth
              />
            </Box>
          </Box>

          <Box mr={{ xs: 0, sm: '1em' }} fullWidth>
            <TextInput
              style={{ marginRight: '1em' }}
              source="adstxt_config.regex"
              label="Ads.txt Search Pattern (Regular Expression)"
              fullWidth
            />
          </Box>

          <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="adstxt_optional"
              label="Ads.txt Optional"
              fullWidth
            />

            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="appadstxt_optional"
              label="App-Ads.txt Optional"
              fullWidth
            />
          </Box>

          <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="domain_approval_required"
              label="Domain Approval Required"
              fullWidth
            />

            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="app_approval_required"
              label="App Approval Required"
              fullWidth
            />
          </Box>

          <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="coppa_enabled"
              label="COPPA Enabled"
              fullWidth
            />

            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="badv_disabled"
              label="BADV Disabled"
              fullWidth
            />

            <BooleanInput
              flex={1}
              mr={{ xs: 0, sm: '1em' }}
              source="block_bots" 
              label="Bot Traffic Bidding Disabled" 
              fullWidth
            />
          </Box>

          <SelectInput
              source="price_adjustment_percent"
              label="Price Adjustment Percent"
              emptyText="- None -"
              allowEmpty
              choices={priceAdustmentChoices()}
              helperText="This is the portion of the price we want to reduce in order to keep the revenue discrepancy 
              between the Bidder and NoBid even. This value is also applied to the floors going out to the Bidder."
              style={{width: '25%'}}
          />

          <NumberInput source="publisher_max_bidprice" 
          label="Max Publisher Bid Price" 
          step={0.01}
          helperText="This is the maximum (ceiling) price above which we reduce the bid price going to the Publisher to."
          style={{width: '25%'}}/>
          
          <br/>

          <NumberInput source="max_refresh_count" label="Max Refresh Count" />

          <FormDataConsumer>
            {({ formData }) =>
              formData.bidder_type === 'RTB' && (
                <div>
                  <BooleanInput
                    source="user_id_optional"
                    label="User ID Optional"
                    style={{ width: '200px' }}
                  />

                  <BooleanInput
                    source="page_url_required"
                    label="Page URL Required"
                    style={{ width: '210px' }}
                  />

                  <br />
                  <TextInput
                    source="sync_id"
                    label="Sync ID"
                    style={{ width: '400px' }}
                  />
                  <br />
                  <TextInput
                    source="sync_url"
                    label="Sync URL"
                    style={{ width: '400px' }}
                  />
                  <BooleanInput
                    source="non_self_compete"
                    label="Non-Self-Compete"
                    style={{ width: '400px' }}
                  />
                  <BooleanInput
                    source="missing_storeurl_disabled"
                    label="Disable Missing App Store URL"
                    style={{ width: '400px' }}
                  />
                  <BooleanInput
                    source="use_current_bids_as_floor"
                    label="Use current bids as floor."
                    style={{ width: '400px' }}
                  />
                  <BooleanInput
                    source="bid_floor_enabled"
                    label="Send predicted floors to Bidder."
                    style={{ width: '400px' }}
                  />
                  <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
                    <NumberInput
                      flex={1}
                      mr={{ xs: 0, sm: '1em' }}
                      source="technology_revshare"
                      label="Technology Revshare %"
                      helperText="This is the only revshare that is going to be applied. This is usually set when using the Publisher Bidder account."
                      style={{width: '15%', paddingRight: '20px'}}
                    />
                    <BooleanInput
                    flex={1}
                    mr={{ xs: 0, sm: '1em' }}
                    source="technology_revshare_cumulative"
                    label="Technology Revshare is Cummulative"
                    helperText="Apply first the Technology revshare, second the NoBid Revshare, thirs the Publisher Revshare."
                    />
                  </Box>
                  <NumberInput
                      source="nobid_revshare"
                      label="NoBid Revshare %"
                      helperText="This revshare will override the NoBid revshare set at the Site or Publisher level."
                      style={{width: '15%', paddingRight: '20px'}}
                    />
                  <br/>
                  <h4>Blocked Advertiser Domains</h4>
                  <TextInput multiline label="Blocked Advertiser Domains"
                  source="badv"
                  validate={validateListSize}
                  helperText="CASE SENSITIVE. Format: advertiserdomain1.com<NEW_LINE>advertiserdomain2.com"
                  style={{ width: '30%' }}
                  />
                </div>
              )
            }
          </FormDataConsumer>
        </FormTab>

        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.bidder_type === 'PREDICTOR' && (
              <FormTab label="Markup Settings" {...rest}>
                <Box fullWidth>
                  <TextInput
                    source="markup"
                    label="Markup"
                    multiline={true}
                    fullWidth
                  />
                </Box>
                <Box fullWidth>
                  <TextInput
                    source="second_markup"
                    label="Secondary Markup"
                    multiline={true}
                    fullWidth
                  />
                </Box>
              </FormTab>
            )
          }
        </FormDataConsumer>

        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.bidder_type === 'RTB' && (
              <FormTab label="RTB Connection" {...rest}>
                <BooleanInput
                  source="is_method_get"
                  label="Get Method"
                  defaultValue={false}
                ></BooleanInput>
                <div style={{ width: '50%' }}>
                  Macros: &#123;&#123;SEAT_ID&#125;&#125;,
                  &#123;&#123;CACHE_BUSTER&#125;&#125;,
                  &#123;&#123;USER_AGENT&#125;&#125;,
                  &#123;&#123;DEVICE_ID&#125;&#125;,
                  &#123;&#123;PAGE_URL&#125;&#125;,
                  &#123;&#123;REFERRER_URL&#125;&#125;,
                  &#123;&#123;PAGE_TOP_LEVEL_DOMAIN&#125;&#125;,
                  &#123;&#123;APP_BUNDLE&#125;&#125;,
                  &#123;&#123;APP_NAME&#125;&#125;,
                  &#123;&#123;APP_STORE_URL&#125;&#125;,
                  &#123;&#123;USER_IP&#125;&#125;, &#123;&#123;DNT&#125;&#125;,
                  &#123;&#123;US_PRIVACY&#125;&#125;,
                  &#123;&#123;WIDTH&#125;&#125;, &#123;&#123;HEIGHT&#125;&#125;
                </div>
                <TextInput
                  source="rtb_connection_info.connection_url"
                  label="Connection URL"
                  style={{ width: '50%' }}
                />
                <NumberInput
                  source="rtb_connection_info.connection_timeout"
                  label="Connection Timeout"
                />
                <NumberInput
                  source="rtb_connection_info.max_connections"
                  label="Max Connections"
                />
                <NumberInput
                  source="rtb_connection_info.max_connections_per_host"
                  label="Connections per Host"
                />

                <ArrayInput
                  source="rtb_connection_info.connection_headers_list"
                  label="Connection Headers"
                >
                  <SimpleFormIterator>
                    <TextInput source="key" label="Key" />
                    <TextInput source="value" label="Value" />
                  </SimpleFormIterator>
                </ArrayInput>

                <BooleanInput
                  source="publisher_id_required"
                  label="Publisher ID Required"
                  style={{ width: '230px' }}
                />

                <BooleanInput
                  source="site_id_required"
                  label="Site ID Required"
                  style={{ width: '190px' }}
                />
                <BooleanInput
                  source="app_id_required"
                  label="App ID Required"
                  style={{ width: '190px' }}
                />
                <BooleanInput
                  source="seat_id_required"
                  label="Seat ID Required"
                  style={{ width: '190px' }}
                />
                <BooleanInput
                  source="size_tag_required"
                  label="Size Tag Required"
                  style={{ width: '200px' }}
                />
                <BooleanInput
                  source="tag_id_required"
                  label="Tag ID Required"
                  style={{ width: '185px' }}
                />
                <BooleanInput
                  source="slot_id_required"
                  label="Slot ID Required"
                  style={{ width: '190px' }}
                />
                <BooleanInput
                  source="append_nurl_to_admarkup"
                  label="Append NURL to AdMarkup"
                  style={{ width: '270px' }}
                />
                <BooleanInput
                  source="is_xandr"
                  label="Is Xandr/Appnexus Bidder?"
                  style={{ width: '270px' }}
                />
                <BooleanInput
                  source="is_magnite"
                  label="Is Magnite/Rubicon Bidder?"
                  style={{ width: '270px' }}
                />
                <TextInput source="openrtb_version" label="OPEN RTB Version" />
              </FormTab>
            )
          }
        </FormDataConsumer>

        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.bidder_type === 'RTB' && (
              <FormTab label="RTB" {...rest}>
                <TextInput style={{width: '40%'}}
                  multiline
                  source="rtb_config.size_tags"
                  helperText="Format: 300x25:ID\n728x90:ID"
                />
                <TextInput style={{width: '40%'}}
                  source="rtb_config.site_id" 
                  label="Site ID" />
                <TextInput style={{width: '40%'}}
                  source="rtb_config.app_id" 
                  label="App ID" />
                <TextInput style={{width: '40%'}}
                  source="rtb_config.publisher_id"
                  label="Publisher ID"
                />
                <TextInput style={{width: '40%'}}
                  source="rtb_config.tag_id" 
                  label="Tag ID" />
                <TextInput style={{width: '40%'}}
                  source="rtb_config.seat_id" 
                  label="Seat ID" />
                <BooleanInput
                  source="rtb_config.prediction_disabled"
                  label="Prediction Disabled"
                />
              </FormTab>
            )
          }
        </FormDataConsumer>

        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.bidder_type === 'RTB' 
            && (
              <FormTab label="Supply Chain" {...rest}>
                <h4 style={{ width: '100%'}}>Supply Chain Settings</h4>
                <BooleanInput
                  source="supplychain_enabled"
                  label="Supply Chain Enabled"
                />
                <SelectInput
                  source="supplychain_complete_value"
                  label="Supply Chain Complete Value"
                  choices={[
                    { id: 0, name: '0' },
                    { id: 1, name: '1' },
                  ]}
                  defaultValue="1"
                />

                <br />
                <TextInput
                  source="supplychain_name"
                  label="Supply chain name. Default is nobid.io"
                  style={{ width: '400px' }}
                />
                <br />
                <TextInput
                  source="supplychain_asi"
                  label="Supply chain ASI. Default is nobid.io"
                  style={{ width: '400px' }}
                />
                <br />
                <TextInput
                  source="supplychain_domain"
                  label="Supply chain domain. Default is nobid.io"
                  style={{ width: '400px' }}
                />
                <h5 style={{ width: '100%'}}>Supply Chain Publisher ID Mapping</h5>
                <ArrayInput source="supplychain_publisherid_mapping" label="" style={{ width: '50%' }}>
                    <SimpleFormIterator>
                      <ReferenceInput source="publisher_id" label="Publisher" reference="publishers"
                          basePath='publishers'
                          perPage={10}
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText })}>
                            <AutocompleteInput label="Publishers" optionText="name" optionValue="code" style={{ width: '100%' }} />
                      </ReferenceInput>
                      
                      <TextInput source="schain_publisher_id" label="Supply Chain Publisher ID" style={{ width: '50%' }}/>
                    </SimpleFormIterator>
                  </ArrayInput>
              </FormTab>
            )
          }
        </FormDataConsumer>

        <FormDataConsumer>
          {({ formData, ...rest }) =>
            !['RTB', 'PREDICTOR'].includes(formData.bidder_type) && (
              <FormTab label="GAM Config" {...rest}>
                <Box p={5} border={1} borderRadius={5} mb={'1em'} fullWidth>
                  <BooleanInput source="adx_api_report" label="ADX Report" />
                  <TextInput
                    source="oauth_path"
                    label="Oauth path"
                    multiline={true}
                    fullWidth
                  />
                  <ArrayInput
                    source="web_property_codes"
                    label="Web property codes"
                  >
                    <SimpleFormIterator>
                      <TextInput label="Code" fullWidth />
                    </SimpleFormIterator>
                  </ArrayInput>
                </Box>
                <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
                  <Box
                    flex={1}
                    mr={{ xs: 0, sm: '1em' }}
                    p={5}
                    border={1}
                    borderRadius={5}
                  >
                    <Typography variant="h6" gutterBottom>
                      {'GAM Bidder Config'}
                    </Typography>
                    <NumberInput
                      source="bidder_gam.adx_order_id"
                      label="ADX Order ID"
                    />
                    <ArrayInput
                      source="bidder_gam.adx_line_item_names"
                      label="ADX Line Items"
                    >
                      <SimpleFormIterator>
                        <TextInput label="Name" fullWidth />
                      </SimpleFormIterator>
                    </ArrayInput>
                  </Box>
                  <Box
                    flex={1}
                    mr={{ xs: 0 }}
                    p={5}
                    border={1}
                    borderRadius={5}
                  >
                    <Typography variant="h6" gutterBottom>
                      {'GAM NoBid Config'}
                    </Typography>
                    <ArrayInput source="line_item_names" label="Line Items">
                      <SimpleFormIterator>
                        <TextInput label="Name" fullWidth />
                      </SimpleFormIterator>
                    </ArrayInput>
                  </Box>
                </Box>
              </FormTab>
            )
          }
        </FormDataConsumer>

        <FormTab label="Reporting">
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            ['RTB', 'DIRECT'].includes(formData.bidder_type) && (
              <div>
              <ScheduledReportButton params={ {
                record: rest.record, 
                end_point: `/run_bidder_report?id=${rest.record.code}`
              } } />
              <Card style={{ width: '90%' }} raised>
                <CardHeader title="Scheduled Reports" />
                <CardContent>
                  <ArrayInput source="report_schedule_config" label="" style={{ width: '50%' }}>
                    <SimpleFormIterator>
                      <br /><span>Scheduled Report Settings</span>
                      <br /><TextInput source="recipients" label="Recipients (comma seperated)" multiline style={{ width: '400px' }} helperText="name@company.com,anothername@company.com" />
                      <br /><SelectInput label="Format" source="format" initialValue="csv"
                        choices={[
                          { id: 'xls', name: 'Excel' },
                          { id: 'csv', name: 'CSV' }
                        ]} />

                      <br />
                      <SelectInput label="Time Period" source="days"
                        initialValue="1"
                        helperText="Select the time period you want the report to run."
                        choices={[
                          { id: '0', name: 'Today' },
                          { id: 1, name: 'Yesterday' },
                          { id: 2, name: 'Last 2 Days' },
                          { id: 3, name: 'Last 3 Days' },
                          { id: 5, name: 'Last 5 Days' },
                          { id: 7, name: 'Last 7 Days' },
                          { id: 8, name: 'Last 8 Days' },
                          { id: 10, name: 'Last 10 Days' },
                          { id: 15, name: 'Last 15 Days' },
                          { id: 30, name: 'Last 30 Days' },
                          { id: 'lm', name: 'Last Month' },
                          { id: 'mtd', name: 'Month to Date' },
                          { id: 'mty', name: 'Month to Yesterday' }
                        ]} />

                      <br />
                      <SelectInput label="Time zone" source="timezone"
                        initialValue="US/Eastern"
                        helperText="Select the time zone you want the report to run."
                        choices={[
                          { id: 'US/Eastern', name: 'US/Eastern' },
                          { id: 'UTC', name: 'UTC' },
                          { id: 'US/Central', name: 'US/Central' },
                          { id: 'US/Mountain', name: 'US/Mountain' },
                          { id: 'US/Pacific', name: 'US/Pacific' },
                        ]} />
                    </SimpleFormIterator>
                  </ArrayInput>
                </CardContent>
              </Card>
              </div>
            )
          }
        </FormDataConsumer>
        </FormTab>
        

        <FormTab label="Monitoring">
					<BooleanInput source="monitoring.enabled" label="Monitoring Enabled" />
					<NumberInput source="monitoring.min_threshold" label="Minimum Hourly Revenue Percentage Threshold" defaultValue={90}
					helperText="Hourly revenue should NOT drop below this percentage value."
          style={{width: '20%'}}/>
					<br/>
          <NumberInput source="monitoring.min_threshold_daily" label="Minimum Daily Revenue Percentage Threshold" defaultValue={90}
					helperText="Daily revenue should NOT drop below this percentage value."
          style={{width: '20%'}}/>
					<br/>
					{/* <NumberInput source="monitoring.max_threshold" label="Maximum Percentage Threshold" defaultValue={100}
					helperText="Hourly or Daily revenue should NOT spike above this percentage value."
          style={{width: '20%'}}/> */}
					<br/>
					<TextInput source="monitoring.email" label="Destination Notification Emails (comma separated)" 
					style={{width: '30%'}}/>
			  </FormTab>

        <FormTab label="Bidder Info">
          <TextInput
            multiline
            source="bidder_info.notes"
            label="Notes"
            helperText="Special notes about this bidder."
            style={{ width: '40%' }}
          />
        </FormTab>

        <FormTab label="Auction Optimizer">
          <SelectInput source="auction_optimizer.test_quota"
            choices={[
                { id: 0, name: '0% - No Test Quota / Always Block' },
                { id: 1, name: '1% - Allow 1% for testing' },
                { id: 2, name: '2% - Allow 2% for testing' },
                { id: 3, name: '3% - Allow 3% for testing' },
                { id: 4, name: '4% - Allow 4% for testing' },
                { id: 5, name: '5% - Allow 5% for testing' },
                { id: 10, name: '10%' },
                { id: 15, name: '15%' },
                { id: 20, name: '20%' },
                { id: 25, name: '25%' },
                { id: 30, name: '30%' },
                { id: 35, name: '35%' },
                { id: 40, name: '40%' },
                { id: 45, name: '45%' },
                { id: 50, name: '50%' },
                { id: 55, name: '55%' },
                { id: 60, name: '60%' },
                { id: 65, name: '65%' },
                { id: 70, name: '70%' },
                { id: 75, name: '75%' },
                { id: 80, name: '80%' },
                { id: 85, name: '85%' },
                { id: 90, name: '90%' },
                { id: 95, name: '95%' },
                { id: 99, name: '99%' },
                { id: 100, name: '100% - Always Allow' },
            ]}
            label="Test Quota" 
            helperText="Quota of traffic for which we do NOT apply the optimization."
            defaultValue={5}
            style={{width: '20%'}}/>
          <hr style={{width: '100%'}} />
          <NumberInput source="auction_optimizer.response_rate_minimum" label="Minimum response rate."
					  helperText="Response rate = bid responses / bid requests. Defaults to 0."
            style={{width: '20%'}}/>
          <NumberInput source="auction_optimizer.fill_rate_minimum" label="Minimum fill rate"
					  helperText="Fill rate = impressions / bid requests. Defaults to 0."
            style={{width: '20%'}}/>
          <NumberInput source="auction_optimizer.net_profit_minimum" label="Ninimum NoBid net profit."
					  helperText="net profit = gross revenue - publisher revenue - cost. Defaults to 0."
            style={{width: '20%'}}/>
          <NumberInput source="auction_optimizer.rpm_minimum" label="Minimum NoBid revenue per million bid requests."
					  helperText="revenue per million bid requests = gross revenue * 1000000 / bid requests. Defaults to 0."
            style={{width: '20%'}}/>
          <NumberInput source="auction_optimizer.rpm_responses_minimum" label="Minimum NoBid revenue per million bid responses."
					  helperText="revenue per million bid responses = gross revenue * 1000000 / bid responses. Defaults to 0."
            style={{width: '20%'}}/>
          <hr style={{width: '100%'}} />
          <NumberInput source="auction_optimizer.bidder_revshare" label="Bidder Revshare. 10, 15 , 20..."
					  helperText="What is the Bidder revshare?"
            style={{width: '15%'}}/>
          <NumberInput source="auction_optimizer.bidder_profit_per_million_bid_requests_minimum" label="Bidder minimum bidder profit per million bid requests."
					  helperText="bidder profit per million bid requests = (bidder revshare/100) * gross revenue * 1000000 / bid requests. Defaults to 0."
            style={{width: '30%'}}/>
          <NumberInput source="auction_optimizer.bidder_profit_per_million_bid_responses_minimum" label="Bidder minimum bidder profit per million bid responses."
					  helperText="bidder profit per million bid requests = (bidder revshare/100) * gross revenue * 1000000 / bid responses. Defaults to 0."
            style={{width: '30%'}}/>
        </FormTab>

        <FormTab label="Spend Summary">
							<NumberField source="revenue_stats.total_impressions" label="Week To Date Impressions" />
							<NumberField source="revenue_stats.total_revenue" label="Week To Date Spend ($)" options={{ style: 'currency', currency: 'USD' }} />
							<NumberField source="revenue_stats.total_bid_requests" label="Week To Date Bid Requests" />
              <NumberField source="revenue_stats.total_bid_responses" label="Week To Date Bid Responses" />
              <NumberField source="revenue_stats.total_response_rate" label="Response Rate" />
              <NumberField source="revenue_stats.total_avg_cpm" label="CPM" />

							<ArrayField source="revenue_stats.daily">
									<Datagrid>
											<CustomDateField label="Date"/>
											<NumberField source="impressions" label="Impressions" />
											<NumberField source="revenue" label="Spend" options={{ style: 'currency', currency: 'USD' }} />
											<NumberField source="avg_cpm" label="CPM" options={{ style: 'currency', currency: 'USD' }} />
											<NumberField source="bid_requests" label="Bid Requests" />
                      <NumberField source="bid_responses" label="Bid Responses" />
									</Datagrid>
							</ArrayField>
					</FormTab>
      </TabbedForm>
    </Edit>
  );
};

const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <br />
    <DateField
      source="updated_at"
      label="Update date"
      style={{ padding: '10px' }}
      showTime
    />
    <TextField source="updated_name" label="" style={{ padding: '10px' }} />
  </Toolbar>
);
